import { useEffect } from 'react';

// Mobile keyboards can resize the visual viewport without resizing layout viewport units.
export function useMobileViewport() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const root = document.documentElement;
    let frame = 0;
    let previousHeight = viewport.height;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        // Keep normal browser panning available when someone zooms the page.
        if (viewport.scale !== 1) {
          root.style.removeProperty('--mobile-viewport-height');
          root.style.removeProperty('--mobile-viewport-top');
          return;
        }
        const height = Math.floor(viewport.height);
        root.style.setProperty('--mobile-viewport-height', `${height}px`);
        root.style.setProperty('--mobile-viewport-top', `${viewport.offsetTop}px`);
        if (height < previousHeight) {
          const active = document.activeElement;
          if (active instanceof HTMLElement && active.closest('[role="dialog"]'))
            active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        previousHeight = height;
      });
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      root.style.removeProperty('--mobile-viewport-height');
      root.style.removeProperty('--mobile-viewport-top');
    };
  }, []);
}
